import Ajax from '@/lib/ajax'

export default {
  /**
   * 获取文章列表
   */
  getArticleList(pageSize: number, currentPage: number, Categories?: string[], Filter?: string, Labels?: string[], IsActive?: boolean) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      Categories,
      Filter,
      Labels,
      IsActive
    }
    return Ajax.get(`/api/Article/Article`, {
      params: params
    })
  },

  /**
   * 新增/更新文章
   * @param obj 
   */
  createOrUpdateArticle(obj: object) {
    let ajaxType = obj['id'] ? 'put' : 'post'
    let url = '/api/Article/Article'
    return Ajax[ajaxType](url, obj)
  },

  /**
   * 获取文章详情
   * @param id 
   */
  getArticleDetail(id: string) {
    return Ajax.get(`/api/Article/Article/${id}`)
  },

  /**
   * 获取指定文章评论列表
   * @param id 
   */
  getArticleComment(ArticleId: string, MaxResultCount: number, currentPage: number) {
    return Ajax.get(`/api/Article/Comment`, {
      params: {
        ArticleId,
        MaxResultCount,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount
      }
    })
  },

  /**
   * 显示/隐藏文章评论
   */
  showOrhiddenComment(id: string) {
    return Ajax.put(`/api/Article/Comment?id=${id}`)
  },

  /**
   * 删除文章
   * @param id 
   */
  deleteArticle(id: string) {
    return Ajax.delete(`/api/Article/Article/?id=${id}`)
  },

  /**
   * 批量设置文章启用
   */
  BatchSetActive(ids: string[], isActive: boolean) {
    return Ajax.post(`/api/Article/Article/BatchSetActive`, {
      ids,
      isActive
    })
  },
  /**
   * 新增/更新文章分类
   * @param obj 
   */
  createOrUpdateCategory(obj: object, id: string) {
    let ajaxType = id ? 'put' : 'post'
    let url = '/api/Article/Category'
    if (id) {
      url += '?id=' + id
    }
    return Ajax[ajaxType](url, obj)
  },

  /**
   * 获取所有文章分类
   */
  getCategoryList() {
    return Ajax.get(`/api/Article/Category/List`)
  },

  /**
   * 获取所有文章标签
   */
  getLabelList() {
    return Ajax.get(`/api/Article/Label/all`)
  },
  /**
   * 获取指定文章分类
   * @param id 
   */
  getCategory(id: string) {
    return Ajax.post(`/api/Article/Category/${id}`)
  },

  /**
   * 新增/更新文章标签
   * @param obj 
   */
  createOrUpdateLabel(obj: object, id: string) {
    let ajaxType = id ? 'put' : 'post'
    let url = '/api/Article/Label'
    if (id) {
      url += '?id=' + id
    }
    return Ajax[ajaxType](url, obj)
  },

  /**
   * 获取指定文章标签
   * @param id 
   */
  getLabel(id: string) {
    return Ajax.get(`/api/Article/Label/${id}`)
  },

}